import React from 'react'

export default function Header() {
  return (
    <h1 className='text-center my-3'>Block Education Office Naraingarh</h1>
  )
}
